var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('with-glossary-entry',{attrs:{"glossary-id":_vm.glossaryId},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var entry = ref.entry;
return [(entry)?_c('span',[_vm._v(_vm._s(entry.glossaryTerm))]):_vm._e()]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }